import React from 'react';
import ContentPreview from '../components/ContentPreview';
import extractContent from './extractContent';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';

// eslint-disable-next-line slab-graphql/no-unused-colocated-fragments
const POST_FRAGMENT = gql(`
  fragment PostPreview_post on PublicPostFields {
    ...PostContent
  }
`);

interface PostPreviewProps {
  charsPerLine?: number;
  numLines?: number;
  post: DocumentType<typeof POST_FRAGMENT>;
}

const PostPreview = ({ post, ...props }: PostPreviewProps) =>
  post?.content ? (
    <ContentPreview content={extractContent(post.content)} {...props} />
  ) : null;

export default PostPreview;
